import {OfferDurationType} from '@core/shared/models/offer/offer-duration';

export const DEFAULT_OFFER_PER_PAGE: number = 21;

export const OFFER_DURATION_TYPE_LABELS: { [p in OfferDurationType]: string } = {
    'day': 'offer.type.day.value',
    'stay': 'offer.type.stay.value'
};
